import { render, staticRenderFns } from "./CollapsibleDocumnetList.vue?vue&type=template&id=77fb41f2&scoped=true"
import script from "./CollapsibleDocumnetList.vue?vue&type=script&lang=js"
export * from "./CollapsibleDocumnetList.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleDocumnetList.vue?vue&type=style&index=0&id=77fb41f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fb41f2",
  null
  
)

export default component.exports